import Location from "../components/home/Location";

export default function ContactUs() {
  return (
    <div>
      <div style={{ height: "70px" }}> </div>
      <div className="container">
        <div className="d-lg-flex d-block p-2 mt-5">
          <h2 className="h1 text-nowrap py-lg-5 py-2">CONTACT US</h2>
          <div className="vl mx-5 bg-warning d-lg-block d-none"></div>
          <div className="w-100 py-2 fs-4">
            <p>
            Let’s Work Together!
We’re here to provide tailored solutions to meet your business needs. Contact us today for inquiries, partnerships, or to learn more about our products and services.


            </p>
          </div>
        </div>
        <hr className="bg-warning" />
        <div className="d-lg-flex d-block ">
          <div className="my-2 mb-4 fs-5 pt-5 mx-2">
            <h3 className="mb-4"> CONTACT </h3>
            <p>
              <strong>Email</strong> <br /> info@ganjtrading.com
            </p>
            <p>
              <strong>Telephone</strong> <br />+964-750-472-2395
            </p>
            <p>
              <strong>Address</strong> <br /> Qazi Mohammad Road, Duhok, Kurdistan Region of Iraq
            </p>
          </div>
          <Location />
        </div>
      </div>
    </div>
  );
}
